export const DEFAULT_MAX_FILE_SIZE = 1024 * 1024 * 1024; // convert 1GB to bytes 
